import lodashGet from 'lodash.get';

export let getValue = (...arg) => {
    if (arg.length === 2) {
        let field = arg[1];
        let label = '';
        if (Array.isArray(field)) {
            label = Array.from(field).pop();
        } else if (typeof field === 'string') {
            label = field.split('.').pop();
        }
        arg.push('-');
    }
    return lodashGet(...arg);
};

export let getEntityType = (typeStr) => {
    if (!typeStr) {
        debugger
    }
    if (typeStr === 'poi') {
        return 'poi';
    }
    if (typeStr === 'user') {
        return 'user';
    }
    // People.User
    if (typeStr.includes('User')) {
        return 'user';
    }

    // Organization.POI Type.Object你很吊哦 基类是你哦
    if (typeStr.includes('POI') || typeStr === 'Type.Object') {
        return 'poi';
    }

    // Tag.TagInfo
    if (typeStr.includes('Tag')) {
        return 'tag';
    }

    // 代表没有返回值
    return null;
};

// 运行一组promise 直到所有的promise全部运行完毕(包括成功和失败)
// TODO PromiseEnd什么时候会 reject 貌似没有理由reject了 😝
export let PromiseEnd = (promiseArr) => {
    // TODO 参数判断 timeout考虑用户自己用race处理 好不好嘛 嗯 好的！
    let endCounter = 0;
    let len = promiseArr.length;
    let promiseValues = new Array(len);

    let resValue = {
        results: promiseValues,
        // TODO try
        getValues: () => promiseValues.map(_ => _.value),
        getStatus: () => promiseValues.map(_ => _.done),
        isResolve: () => {
            for (let i = 0, len = promiseValues.length; i < len; i++) {
                let value = promiseValues[i];
                if (value && value.done === false) {
                    return false;
                }
            }
            return true;
        },
        getReject: () => promiseValues.filter(_ => !_.done).map(_ => _.value),
    };

    let res:any =  new Promise((resolve, reject) => {
        let checkEnd = () => {
            endCounter++;
            if (endCounter === len) {
                resolve(resValue);
            }
        };
        for (let i = 0; i < len; i++) {
            Promise.resolve(promiseArr[i]).then((value) => {
                promiseValues[i] = {
                    done: true,
                    value: value,
                };
                checkEnd();
            }).catch((reason) => {
                promiseValues[i] = {
                    done: false,
                    value: reason,
                };
                checkEnd();
            })
        }
    });

    return res;
};















